<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">
    <div class="is-flex">
      <!--添加产品分类-->
      <div class="common-level-rail">
        <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/promotion/promoter/add'">添加等级</el-button>
      </div>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="等级名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入等级名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="id" border default-expand-all :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">
          <el-table-column prop="name" align="center" label="等级名称" width="180"></el-table-column>
          <el-table-column prop="waiterScale" align="center" label="技师比例"></el-table-column>
          <el-table-column prop="userScale" align="center" label="用户比例"></el-table-column>
          <el-table-column prop="twoWaiterScale" align="center" label="技师二级比例"></el-table-column>
          <el-table-column prop="twoUserScale" align="center" label="用户二级比例"></el-table-column>
          <el-table-column prop="isDefault" align="center" label="是否默认等级">
            <template slot-scope="scope">
              {{scope.row.isDefault!=1?'否':'是'}}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small" v-auth="'/promotion/promoter/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small" v-auth="'/promotion/promoter/delete'" v-if="scope.row.id!=1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="promoterModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="promoterModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import PromotionApi from "@/api/promotion.js";
import Add from "./Add.vue";
import Edit from "./Edit.vue";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*列表数据*/
      tableData: [],
      /*横向表单数据模型*/
      searchForm: {
        name: ""
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      promoterModel: {
        catList: [],
        model: {}
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    hasImages(e) {
      if (e) {
        return e.filePath;
      } else {
        return "";
      }
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let params = {};
      params.name = self.searchForm.name;
      params.pageIndex = self.curPage;
      params.pageSize = self.pageSize;

      PromotionApi.PromotionGrade(params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.promoterModel.model = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*删除分类*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          PromotionApi.PromotionGradeDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped lang=''>
.is-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/promoter/index.vue